import React from 'react'
import Helmet from 'react-helmet'

import '../assets/styles/fonts.scss'
import '../assets/styles/main.scss'

// import favicon16 from '../assets/images/favicon_16px.png'
// import favicon32 from '../assets/images/favicon_32px.png'
// import favicon96 from '../assets/images/favicon_96px.png'

const description = ""
const title = "Dark"

export default ({ children }) => (
  <div>
    <Helmet>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta property="description" content={ description } />
      <meta property="og:description" content={ description } />
      <meta property="og:image" content={``} />
      <meta property="og:title" content={ title } />
      <title>{ title }</title>
    </Helmet>
    {children()}
  </div>
)



// WEBPACK FOOTER //
// ./src/layouts/index.js